import * as React from 'react';
import "./HomeCarousel.css"
import { map } from 'lodash';
import { AnimatePresence, motion } from "framer-motion"
import { useState } from 'react';
import { useEffect } from 'react';
import { VideoButtonGroup } from '../Buttons/VideoButtonGroup';
import { Image } from '../Image/Image';
import styled from 'styled-components'
import { VideoModel } from '../../Models/Video.interface';

let timeout: any
export const HomeCarousel = () => {

    const [ activeIndex, setActiveIndex] = useState<number>(0)
    const [ auto, setAuto] = useState(true)
    useEffect(() => {
        if(auto){
            timeout = setTimeout(() => {
                if(activeIndex >= data.length - 1){
                    setActiveIndex(0)
                } else {
                    setActiveIndex(activeIndex + 1)
                }
            }, 6000)
        } else {
            clearTimeout(timeout)
        }


    }, [activeIndex, auto])

    const onUserSelect = (value: number) => {
        setAuto(false)
        setActiveIndex(value)
    }

    return(
        <div className="carousel-background">
        <AnimatePresence >
            
            {map(data, (d:HomeCarouselData, i: number) => {
                return(
                    activeIndex === i && <motion.div 
                    key={`carousel-${i}`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{duration: 1}}
                    exit={{ opacity: 0 }}
                    style={{position: 'absolute'}}

                        >
                         <CarouselCard {...d}/>
                    </motion.div>
                )
            })}
           
        </AnimatePresence>
        <CarouselPicker 
            active={activeIndex} 
            count={data.length}
            onClick={onUserSelect}
            />
        </div>
    )
}


type HomeCarouselData = {
    id: number
    uuid: string
    video: string
    air_date: string
    poster: string
    thumbnail: string
    name: string
    duration?: number
    tags?: string[]
    logo?: string
    long_text: string
}


const data: HomeCarouselData[] = [
    {
        id: 12659,
        name: "History's Most Hated Father",
        air_date: "2021-06-20",
        thumbnail: "https://itiswrittenvod.akamaized.net/25fe1281-684a-4565-a582-1f082ec44418/7e2fbaf5-364f-4082-a28e-74a179d4ac47/aec9895a-04b9-405d-a5e8-ded2867c6b4a/thumbnail.jpg",
        poster: "https://itiswrittenvod.akamaized.net/25fe1281-684a-4565-a582-1f082ec44418/7e2fbaf5-364f-4082-a28e-74a179d4ac47/aec9895a-04b9-405d-a5e8-ded2867c6b4a/poster.jpg",
        // poster:"https://uploads-ssl.webflow.com/5e9e46ade2658e4e305d3d8e/5eaa0c5144c117dd8473b9b1_Man%20of%20Faith.jpg",
        long_text: "There is one man in history, one father, who is hated above all others, and it's not who you think. Join John Bradshaw as he reveals the mystery, gives advice for understanding your own father, and presents some valuable resources to help you become a better parent.  Don’t miss “History’s Most Hated Father.”",
        uuid: "7e2fbaf5-364f-4082-a28e-74a179d4ac47",
        video: "https://itiswrittenvod.akamaized.net/25fe1281-684a-4565-a582-1f082ec44418/7e2fbaf5-364f-4082-a28e-74a179d4ac47/5ffe051a-1f90-46fb-9bba-572c789ac608/video_h264.m3u8",
        tags: [
            "award-winning",
            "weekly",
            "popular"
        ],
        logo: "https://uploads-ssl.webflow.com/5e9e46ade2658e4e305d3d8e/5ea9f13402dbf79988a6c321_IIW%20Flagship%20logo.png",
        duration: 28
    },
    {
        id: 12367,
        name: "John T. Boston II",
        air_date: "2021-04-05",
        thumbnail: "https://itiswrittenvod.akamaized.net/e8b05e91-d042-4541-a6c4-ab0e1127384b/2fbf5799-4492-4d75-8f42-31f379cca7b0/d983caa2-d3b2-450e-8552-da2811752761/thumbnail.jpg",
        poster: "https://itiswrittenvod.akamaized.net/e8b05e91-d042-4541-a6c4-ab0e1127384b/2fbf5799-4492-4d75-8f42-31f379cca7b0/d983caa2-d3b2-450e-8552-da2811752761/poster.jpg",
        long_text: "Miraculously saved by an angel, and recently reunited with his birth mother, John Boston shares the incredible story of God’s grace in his life.",
        uuid: "2fbf5799-4492-4d75-8f42-31f379cca7b0",
        video: "https://itiswrittenvod.akamaized.net/e8b05e91-d042-4541-a6c4-ab0e1127384b/2fbf5799-4492-4d75-8f42-31f379cca7b0/d983caa2-d3b2-450e-8552-da2811752761/video.m3u8",
        tags: [
            "inspirational",
            "feel-good",
            "interview"
        ],
        logo: "https://uploads-ssl.webflow.com/5e9e46ade2658e4e305d3d8e/5ea9f13402dbf7d73fa6c320_Conversations%20logo%20(white%20text).png",
        duration: 28
    },
    {
        id: 12646,
        name: "Don’t Fall for That",
        air_date: "2021-06-24",
        thumbnail: "https://itiswrittenvod.akamaized.net/1c68d4a9-f17a-47e2-82ca-7661ea3737c2/6ada5fb8-567d-417a-a2f8-91f0d7deb6a4/a137bfe4-64cc-4633-b347-1515c1056936/thumbnail.jpg",
        poster: "https://itiswrittenvod.akamaized.net/1c68d4a9-f17a-47e2-82ca-7661ea3737c2/6ada5fb8-567d-417a-a2f8-91f0d7deb6a4/a137bfe4-64cc-4633-b347-1515c1056936/poster.jpg",
        long_text: "You have ample evidence.\r\n\r\n“Unless you see signs and wonders you will not believe.”\r\n- John 4:48 RSV",
        uuid: "6ada5fb8-567d-417a-a2f8-91f0d7deb6a4",
        video: "https://itiswrittenvod.akamaized.net/1c68d4a9-f17a-47e2-82ca-7661ea3737c2/6ada5fb8-567d-417a-a2f8-91f0d7deb6a4/064bfa2d-7b80-45c1-957f-a87632bdf7fd/video_h264.m3u8",
        tags: [
            "daily",
            "devotional",
            "quick"
        ],
        logo: "https://uploads-ssl.webflow.com/5e9e46ade2658e4e305d3d8e/5ea9f1346f2df341fccc0b42_Every%20Word%20logo.png",
        duration: 1
    },

]

const TagContainer = styled.div`
    display: flex;
    align-items: center;
`


const CarouselCard = (props: HomeCarouselData) => {
    const {logo, poster, name, long_text, duration, tags } = props
    const style={
        backgroundImage: `radial-gradient(circle farthest-corner at 100% 50%, transparent 25%, rgba(17, 18, 25, 0.5) 60%, #111219), url(${poster})`,
        backgroundBlendMode: 'hard-light',
        transition: 'background 0.2s ease-in-out'
    }

    const renderTags = () => {
        if(!tags){
            return <></>
        }
        return( 
        <div className="carousel-tag-container">
            {
            map(tags, (tag, i) => {
            return (
                <TagContainer key={`weoifjwoefij-${i}`}>
                   <h4 
                       className="carousel-tag"
                       style={{ marginLeft: i === 0 ? 0 : '1em', marginRight: '1em'}}
                    >
                        {tag}
                   </h4>
                   {(i !== tags.length - 1) && <h4 className="carousel-tag">|</h4>}
                </TagContainer>
                )
            })}
       </div>  
        )
    }

    const renderTitleSection =() => {
        return(
            <div className="carousel-title-section">
            <h2>{name}</h2>
            <p className="carousel-duration">{`${duration} min`}</p>
            <div className="carousel-new-tag">NEW</div>
        </div>
        )
    }

    const renderBottomButtons = () => {
        return(
            <VideoButtonGroup 
                video={props as unknown as VideoModel}
            />
        )
    }


    return(
        <div className="carousel-background"
            style={style}
        >
            <div className="carousel-container">
                
                <Image src={logo} alt="logo"/>
                {renderTitleSection()}
                <p className="carousel-long-text">{long_text}</p>
                {renderTags()}
                {renderBottomButtons()}
     
            </div>

            
        </div>
    )
}

type CarouselPickerProps = {
    count: number
    active: number
    onClick: any
}

const CarouselPicker = (props: CarouselPickerProps) => {
    const {count, active, onClick} = props


    return(
        <div className="carousel-dot-container">
            {map(new Array(count), (blank :any, i:number) => {
                const _onClick = () => {
                    if(!!onClick){
                        onClick(i)
                    }
                }
                return (
                    <div
                        onClick={_onClick}
                        key={`carousel-dot-${i}`}
                        className="carousel-dot"
                        style={{
                            backgroundColor: active === i ? "white" : "rgba(255,255,255,0.4)" 
                        }}
                    >
                    </div>
                )
            })}
        </div>
    )
}